import { toast } from "sonner";
import baseApi from "store/api/baseApi";

const transactionManagementApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    // Get all transactions
    getAllTransactions: builder.query({
      query: () => ({
        url: "qwikITTransaction/",
        method: "GET",
      }),
      providesTags: ["transactions"],
      transformResponse: response => response,
    }),

    // Get a single transaction by ID
    getTransaction: builder.query({
      query: id => ({
        url: `qwikITTransaction/${id}/`,
        method: "GET",
      }),
      providesTags: ["transactions"],
      transformResponse: response => response,
    }),

    // Create a new transaction
    createTransaction: builder.mutation({
      query: data => ({
        url: "qwikITTransaction/new/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["transactions"],
      transformResponse: response => {
        toast.success("Transaction added successfully");
        return response;
      },
    }),

    // Update transaction
    updateTransaction: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `qwikITTransaction/${id}/`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["transactions"],
      transformResponse: response => {
        toast.success("Transaction updated successfully");
        return response;
      },
    }),

    // Delete transaction
    deleteTransaction: builder.mutation({
      query: id => ({
        url: `qwikITTransaction/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["transactions"],
      transformResponse: response => {
        toast.success("Transaction deleted successfully");
        return response;
      },
    }),
  }),
});

export const {
  useGetAllTransactionsQuery,
  useGetTransactionQuery,
  useCreateTransactionMutation,
  useUpdateTransactionMutation,
  useDeleteTransactionMutation,
} = transactionManagementApi;